import './assets/images/flat(1).webp';
import './assets/images/programmer-man.webp';
import './assets/images/work3.webp';


export const lightTheme = {
  header: '#eee',
  body: 'whitesmoke',
  text: '#868e96',
  toggleBorder: '#FFF',
  heading: '#5b6166',
  title: '#303e49',
  gradient: 'linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);',
};

export const darkTheme = {
  header: '#121225',
  body: '#17172f',
  text: '#fff',
  toggleBorder: '#6B8096',
  heading: '#eee',
  title: '#eee',
  gradient: 'linear-gradient(#091236, #1E215D)',
};